import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import WhoWeAre from "./components/WhoWeAre";
import Leadership from "./components/Leadership";
import Stats from "./components/Stats";
import Advisory from "./components/Advisory";
import KnowMo from "./components/KnowMo";
import Ember from "./components/Ember";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import useReveal from "./hooks/useReveal";

const Home = () => {
  useReveal();
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero />
        <WhoWeAre />
        <Leadership />
        <Stats />
        <Advisory />
        <KnowMo />
        <Ember />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  useEffect(() => {
    document.title = "Golden Bridge Business LLC | Capital Advisory, KnowMo SaaS & Ember Compute";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;